
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/laravel-development",
      function () {
        return require("private-next-pages/laravel-development/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/laravel-development"])
      });
    }
  